module.exports = __webpack_public_path__ + "img/xz.0f7d92a6.svg";